import {
    Select,
    SelectValue,
    SelectTrigger,
    SelectContent,
    SelectItem,
} from "@/components/ui/select";
import { SortOptions } from "@/types/enums";
import { useDispatch, useSelector } from "react-redux";
import {
    selectSelectedSort,
    setSelectedSort,
} from "@/features/filters/filtersSlice";

type SortOption = {
    value: SortOptions;
    label: string;
};

const sortOptions: SortOption[] = [
    { value: SortOptions.VACANCY_ASCENDING, label: "Availability: Low - High" },
    {
        value: SortOptions.VACANCY_DESCENDING,
        label: "Availability: High - Low",
    },
    { value: SortOptions.PRICE_ASCENDING, label: "Price: Low - High" },
    { value: SortOptions.PRICE_DESCENDING, label: "Price: High - Low" },
    { value: SortOptions.AREA_ASCENDING, label: "Size: Small - Large" },
    { value: SortOptions.AREA_DESCENDING, label: "Size: Large - Small" },
];

export const UnitTableSort = () => {
    const dispatch = useDispatch();
    const selectedSort = useSelector(selectSelectedSort);

    return (
        <Select
            value={selectedSort}
            onValueChange={(value) => dispatch(setSelectedSort(value))}
        >
            <SelectTrigger>
                <SelectValue placeholder="Sort By" />
            </SelectTrigger>
            <SelectContent className="se-vapor se-vapor-sort">
                {sortOptions.map(({ value, label }) => (
                    <SelectItem value={value} key={value}>
                        {label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
